// ** Third Party Imports
import { useRoutes } from 'react-router-dom'
import { wrapUseRoutes } from '@sentry/react'

// ** Route Imports
import { publicRoutes } from './publicRoutes'

/**
 * fortunai.co serves only the static marketing website.
 * Protected/dashboard routes are intentionally no longer registered here —
 * all application access happens through app.fortunai.co.
 */
export const AppRoutes = () => {
	const useSentryRoutes = wrapUseRoutes(useRoutes)
	const element = useSentryRoutes(publicRoutes)

	return <>{element}</>
}
